import { render, staticRenderFns } from "./modal-historico-geracao-itens.vue?vue&type=template&id=55d0382a&scoped=true"
import script from "./modal-historico-geracao-itens.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-geracao-itens.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-situacao.scss?vue&type=style&index=0&id=55d0382a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0382a",
  null
  
)

export default component.exports